import { TTransshipmentStepId } from '../../types';

const step = {
  path: 'senha-acesso',
  next: (): TTransshipmentStepId => 'success-page',
};

export default step;
